import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { ConsumerProposalsState } from "../../models/mp-admin/consumer-proposals-state";

const initialState: ConsumerProposalsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpAdminActions.consumerProposals.getApi, (state) =>
		_.set(_.cloneDeep(state), "loading", true)
	),
	on(MpAdminActions.consumerProposals.getSuccess, (state, action) => _.omit(action, "type")),
	on(MpAdminActions.consumerProposals.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

export function consumerProposalsReducer(
	state: ConsumerProposalsState,
	action: Action
): ConsumerProposalsState {
	return reducer(state, action);
}
